module.exports = __webpack_public_path__ + "img/img-10.dcd6e9d9.png";